import {
  CovToast,
  CovUploader,
  ToastStyle,
  ToastType,
} from "@cx-component-library/react-components";
import { Box } from "@mui/material";
import {
  ALLOWED_UPLOAD_FORMATS,
  MAX_UPLOAD_FILE_SIZE,
  useImageUpload,
} from "../../upload/useImageUpload";

/**
 * Compact drag-drop prompt shown in place of the Reference Image card once
 * the upload flow's progress has been discarded (CX-2908) — same
 * `CovUploader` validation/behavior as {@link ImageUploadPanel}. No custom
 * `textContent` is passed, so `CovUploader` renders its own built-in
 * "Drag your file or browse" prompt, matching the compact "Upload & Match"
 * reset state in Figma (node 879:23836) — that Figma state has no
 * format/size hint line, so the library's own `.additional` hint block
 * (rendered internally, with no prop to opt out) is hidden via a scoped
 * selector rather than duplicated with custom textContent.
 */
export const CompactImageUploader = () => {
  const { handleFilesDropped, handleFileError, toastMessage, clearToast } =
    useImageUpload();

  return (
    <>
      <Box sx={{ "& .drop-space-content .additional": { display: "none" } }}>
        <CovUploader
          maxFileSize={MAX_UPLOAD_FILE_SIZE}
          allowedFormats={ALLOWED_UPLOAD_FORMATS}
          allowedFileExtensions=".png,.jpg,.jpeg,.webp"
          onFilesDropped={handleFilesDropped}
          onFileError={handleFileError}
        />
      </Box>
      <CovToast
        visible={!!toastMessage}
        toastType={ToastType.DANGER}
        toastStyle={ToastStyle.FILLED}
        message={toastMessage ?? ""}
        hasCancelIcon
        autoHideDuration={6000}
        onClose={clearToast}
      />
    </>
  );
};
